<template>
  <div class="container">
    <div class="app-list">
      <app-item
          @showPlayer="showPlayer"
          :app="apps[0]" />
      <app-item
          @showPlayer="showPlayer"
          :app="apps[1]" />
    </div>
    <div class="app-list">
      <app-item
          @showPlayer="showPlayer"
          :app="apps[2]" />
      <soon-item
          :soon="soonList[0]" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import appItem from './app-item';
  import soonItem from './soon-item';

  export default {
    name: 'app-list',

    components: {
      appItem,
      soonItem,
    },

    data: () => ({
    }),

    computed: {
      ...mapGetters(['apps']),
      ...mapGetters(['soonList']),
    },

    methods: {
      showPlayer(videoId) {
        this.$emit('showPlayer', videoId);
      },
    },
  }
</script>
